
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#474747","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"15"}},[_c('path',{attrs:{"d":"M21.607 180.441l125.414 85.388a44.098 44.098 0 0034.025 6.675l66.945-14.292a35.038 35.038 0 017.312-.772h110.303V263c0 21.23-17.211 38.441-38.441 38.441h-43.656c-7.568 0-14.77 3.25-19.777 8.925h0c-11.282 12.786-7.648 32.757 7.415 40.749l13.807 7.326a26.384 26.384 0 0012.052 3.075l78.601.925 70.465-9.977c23.706-3.357 45.794 12.714 49.896 36.302l.639 3.676-116.248 20.072-95.752 1.928m185.903-16.775c9.236 5.727 16.123 14.155 18.31 25.642l.787 4.133-101.248 23.072-89 5"}}),_c('path',{attrs:{"d":"M463.884 434.059c6.165 3.903 10.792 10.238 12.308 18.008l2.414 12.374-95.248 21.072-86.627 2.762a35.312 35.312 0 01-14.225-2.496l-76.666-30.991a130.749 130.749 0 01-41.824-26.625l-55.659-52.65-92.752-46.072M496.358 84.514l-65.717-3.186v30.769h-76V69.846c0-20.154 15.29-37.02 35.347-38.992l106.37-10.34M394.141 81.097h-36M21.358 88.514l137.187 110.007a36.638 36.638 0 0037.781 6.756l62.004-22.242a42.941 42.941 0 0114.496-2.521h71.533M430.358 141.514v160M430.358 325.514v3M399.358 203.514v40M399.358 176.514v4M354.358 141.514v81M455.358 308.514l19-35M470.358 326.514l19-6"}})])])
          )
        }
      }
    